module.exports = __webpack_public_path__ + "img/logo.a5f2e196.png";